import { render } from "./SoftwareProjectsComponent.vue?vue&type=template&id=50c30fc1&ts=true"
import script from "./SoftwareProjectsComponent.vue?vue&type=script&lang=ts"
export * from "./SoftwareProjectsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__